import {MainSearchConfig} from "@/core/types";

const API_KEY_DEFAULT = "api_key_undefined";
const REST_API_DOMAIN_DEFAULT = "orion.quarticon.com"
const CUSTOMER_SYMBOL_DEFAULT = "customer_undefined"
const SEARCH_ID_DEFAULT = "search_id_undefined"

export const config: MainSearchConfig = {
  apiKey: window?.SmartSearchConfig?.apiKey || API_KEY_DEFAULT,
  apiHost: window?._QONizer?.domains?.restApiDomain || REST_API_DOMAIN_DEFAULT,
  customerSymbol: window?.SmartSearchConfig?.customerSymbol || CUSTOMER_SYMBOL_DEFAULT ,
  searchId: window?.SmartSearchConfig?.searchId || SEARCH_ID_DEFAULT
}

